import { SessionLogoutListenerInterface } from '../types';

export class SessionLogoutListenerMock implements SessionLogoutListenerInterface {
  // @ts-ignore
  // tslint:disable-next-line
  public async init(ticketNumber?: string) {}

  // tslint:disable-next-line
  public close() {}
}
